import React from 'react';

import SharedNotFoundPage from '@tt/utils/notFoundPage';

import LogoImg from '../../resources/images/Logo.svg';

const NotFoundPage = () => (
    <SharedNotFoundPage
        appName="Journal"
        homeHref="/"
        logoSrc={LogoImg}
        logoAlt="Trading Journal"
        logoWidth={198}
    />
);

export default NotFoundPage;
